// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1MPQw","buttons":"Footer_buttons__1XCP3"};